// extracted by mini-css-extract-plugin
export default {"base":"EditLabelError_base__AUhE+"};